import { render, staticRenderFns } from "./QuickPayPage.vue?vue&type=template&id=2214248b&scoped=true"
import script from "./QuickPayPage.vue?vue&type=script&lang=js"
export * from "./QuickPayPage.vue?vue&type=script&lang=js"
import style0 from "./QuickPayPage.vue?vue&type=style&index=0&id=2214248b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214248b",
  null
  
)

export default component.exports